module.exports = __webpack_public_path__ + "static/media/icon-success-rate-3x.0df9840b.png";